module.exports = __webpack_public_path__ + "static/media/modern-data-stack.b9e3ca91.jpg";